import { render, staticRenderFns } from "./PlatInfo.vue?vue&type=template&id=df4cb904&scoped=true&"
import script from "./PlatInfo.vue?vue&type=script&lang=js&"
export * from "./PlatInfo.vue?vue&type=script&lang=js&"
import style0 from "./PlatInfo.vue?vue&type=style&index=0&id=df4cb904&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df4cb904",
  null
  
)

export default component.exports